export function clean(obj) {
  for (var propName in obj) {
    if (
      obj[propName] === '' ||
      obj[propName] === undefined ||
      obj[propName] === null
    ) {
      delete obj[propName];
    }
  }
  return obj;
}

export function isVideo(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
      // do nothing
      // etc
      return true;
    default:
      return false;
  }
}

function getExtension(filename) {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}
